export default __webpack_public_path__ + "static/media/cases3.3758803c.jpg";